import React from 'react';

import CompanySelector from '../CompanySelector/CompanySelector';
import UserSelector from '../UserSelector/UserSelector';

import './Header.scss';

export interface IHeaderProps {
  displayCompanySelector?: boolean;
}

const Header = ({ displayCompanySelector = true }: IHeaderProps) => {
  return (
    <header className="header-v3" data-experience="new">
      <div className={`content-container ${!displayCompanySelector && 'without-company-selector'}`}>
        {displayCompanySelector && <CompanySelector />}
        <div className="header-options">
          <UserSelector />
        </div>
      </div>
    </header>
  );
};

export default Header;
